export enum ReceiptTemplateType {
    Sales = 1,
    Kitchen = 2,
    Order = 3,
    PayIn = 4,
    PayOut = 5,
    Deposite = 6,
    POSTerminalSummaryReport = 7,
    POSTerminalSummaryReportWitchCashActivities = 8,
    POSTerminalSummaryReportWithSalesTransactions = 9,
    POSTerminalSummaryReportFull = 10,
    CloseOfDayReport = 11,
    BillPreview = 19,
    DeliveryTicket = 20,
    TableServiceSales = 21,
    TableServiceBillPreview = 22,
    Refund = 24,
}
